import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, Subscription, forkJoin } from 'rxjs';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IngredientService } from '../ingredient/ingredient.service';
import { HostService } from '../host/host.service';
import { PdvService } from '../pdv/pdv.service';

@Injectable()
export class OrdersService {
  months = [];
  host: string;
  orderTemp: any = {
    elements: [],
    menus: [],
    amount: 0,
    comment: '',
    elementsNbr: 0,
    total: 0,
    discount: 0,
    discountValue: 0,
    couponCode: 0,
    coupon: 0,
    couponValue: 0,
    couponType: 0,
    fees: 0,
    feesLabel: ""
  };
  offerNbrTemp: number = 0;
  public order: BehaviorSubject<any> = new BehaviorSubject<any>({
    elements: [],
    menus: [],
    amount: 0,
    comment: '',
    elementsNbr: 0,
    total: 0,
    discount: 0,
    discountValue: 0,
    couponCode: 0,
    coupon: 0,
    couponValue: 0,
    couponType: 0,
    fees: 0,
    feesLabel: ""
  });
  public enablePayement: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public orderType: BehaviorSubject<number> = new BehaviorSubject<number>(1);
  public chosenOrderType: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public orderProg: BehaviorSubject<Date> = new BehaviorSubject<Date>(new Date());
  public offerNbr: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  public address: BehaviorSubject<any> = new BehaviorSubject<any>({
    id: null,
    address: "",
    city: "",
    postalCode: null,
    streetNumber: null,
    streetName: ""
  });
  amountMiniMandatory = 0;
  discount = 0;
  discountFrom = 0;
  couponValue = 0;
  public amountMiniDelivery: BehaviorSubject<number> = new BehaviorSubject<number>(0);
  subscriptions: Subscription[] = [];
  constructor(
    private http: HttpClient,
    private toastr: ToastrService,
    private ingredientsService: IngredientService,
    private hostService: HostService,
    private pdvService: PdvService,
  ) {
    this.host = this.hostService.host;

    this.pdvService.pdv.subscribe(
      (data: any) => {
        this.amountMiniMandatory = data.amountMiniMandatory;
        this.discount = data.discount;
        this.discountFrom = data.discountFrom;
      }
    )
  }



  addElementToBasket(p) {
    return new Promise(
      (v, x) => {
        let error = 0;
        let product = JSON.parse(JSON.stringify(p));
        if (!(product.size >= 0)) {
          error++;
          this.toastr.error('Produit indisponible pour le moment', 'Attention', { positionClass: 'toast-top-center' })
          return x(1);
        }
        product.selectedOpt = product.optionIngredients.filter(c => c.disabled == "false" && c.checked);
        if (product.custom) {
          if (product.selectedOpt.length == 0) {
            error++;
            this.toastr.error('Merci d\'ajouter les options', 'Attention', { positionClass: 'toast-top-center'});
            this.goto('optionsObligatory');
            return x(1);
          } else {
            product.obligatoryIngredient.forEach(cat => {
              let array = product.selectedOpt.filter(o => o.category == cat.id);
              if (error == 0 && array.length < cat.maxNbrIngOptions) {
                error++;
                let message = "Merci de selectionner au moins \r\n" + cat.maxNbrIngOptions + ' ingredient(s) de la categorie ' + cat.category;
                this.toastr.error(message, 'Attention', { positionClass: 'toast-top-center' })
                this.goto('categoryopt_' + cat.id);
                return x(1);
              }
              if (error == 0 && array.length > cat.max2NbrIngOptions && cat.max2NbrIngOptions > 0) {
                error++;
                let message = "Le nombre max d'ingredients pour la categorie " + cat.category.toLowerCase() + "  c'est \r\n" + cat.max2NbrIngOptions;
                this.toastr.error(message, 'Attention')
                this.goto('categoryopt_' + cat.id);
                return x(1);
              }
            });
          }
        }
        product.selectedSupp = product.supplements.filter(c => c.disabled == "false" && c.checked);
        if (error == 0 && product.selectedSupp.length == 0 && product.obligatorySupp.length > 0) {
          error++;
          this.goto('suppObligatory');
          this.toastr.error('Merci d\'ajouter les suppléments  oblégatoire', 'Attention', { positionClass: 'toast-top-center' });
          return x(1);
        }
        if (product.selectedSupp.length > 0 && product.obligatorySupp.length > 0) {
          product.obligatorySupp.forEach(cat => {
            let array = product.selectedSupp.filter(c => c.category == cat.id);
            if (error == 0 && array.length < cat.minNbrIngOptions) {
              error++;
              let message = "Merci de selectionner au moins \r\n" + cat.minNbrIngOptions + ' ingredient(s) de la categorie ' + cat.category;
              this.toastr.error(message, 'Attention', { positionClass: 'toast-top-center' })
              this.goto('categorysupp_' + cat.id);
              return x(1);
            }
            if (error == 0 && array.length > cat.maxNbrIngOptions && cat.maxNbrIngOptions > 0) {
              error++;
              let message = "Le nombre max d'ingredients pour la categorie " + cat.category.toLowerCase() + "  c'est \r\n" + cat.maxNbrIngOptions;
              this.toastr.error(message, 'Attention')
              this.goto('categorysupp_' + cat.id);
              return x(1);
            }
          });
        }
        if (error == 0) {
          let element = {
            id: product.id,
            code: product.code,
            name: product.name,
            family: product.family,
            size: product.sizes[product.size],
            comment: (product.comment) ? product.comment : '',
            qty: Number(product.qty),
            removedCompositions: product.compositions.filter(c => c.disabled == "false" && !c.checked),
            supplements: [],
            optionIngredients: product.optionIngredients.filter(c => c.disabled == "false" && c.checked),
            total: 0,
            vat: product.vat,
            priceSuppApp: product.priceSuppApp,
            priceWithSupp: Number(product.sizes[product.size].price),
            maxNbrIngOptions: product.maxNbrIngOptions,
            hasSupp: product.hasSupp,
            canUpdate: true,
            index: product.index
          }
          if (product.selectedOpt.length > 0) {
            let totalprice = product.selectedOpt.reduce((a, b) => a + Number(b.productSupp), 0);
            element.size.price = Number(element.size.price) + Number(totalprice);
          }
          element.total += Number(element.size.price);
          if (product.selectedSupp && product.selectedSupp.length > 0) {
            let supplements = product.selectedSupp;
            let totalSupp = product.selectedSupp.reduce((a, b) => +a + +b.price, 0);
            let totaloffert = product.selectedSupp.reduce((a, b) => a + Number(b.nbrSuppOfferts), 0);
            if (totaloffert > 0) {
              this.getSelectedCat(supplements).then(
                (selectedCat: any) => {
                  this.setOffertIngPrice(selectedCat).then(
                    (d: any) => {
                      element.supplements = d.supplements;
                      element.total += d.totalSupp;
                      element.total *= element.qty;
                      this.addElementToOrder(element);
                      return v(1);
                    }
                  )
                }
              )
            } else {
              element.supplements = supplements;
              element.total += totalSupp;
              element.total *= element.qty;
              this.addElementToOrder(element);
              return v(1);
            }
          } else {
            element.total *= element.qty;
            this.addElementToOrder(element);
            return v(1);
          }
        }
      }
    )
  }


  goto(el) {
    let item = document.getElementById(el);
    if (item) {
      let elements = document.getElementsByClassName('flash');
      while (elements.length > 0) {
        elements[0].classList.remove('flash');
      }
      item.scrollIntoView({ behavior: 'smooth' });
      item.classList.add("flash");
    }
  }


  addElementToOrder(p) {
    if (typeof p.index !== 'undefined') {
      this.updateElement(p, p.index)
    } else {
      this.orderTemp.elements.unshift(p);
      this.toastr.success('Ajout Produit', 'Ajout réussi');
      this.changeOrderTotal();
    }
  }


  getSelectedCat(selectedSupp) {
    return new Promise((resolve, reject) => {
      let selectedCat = [];
      selectedSupp.forEach(((x, j) => {
        let index = selectedCat.findIndex(ee => ee.id == x.category);
        if (index > -1) {
          selectedCat[index].elements.push(x);
          selectedCat[index].elements.sort((a, b) => {
            return Number(a.price) + Number(a.productSupp) - Number(b.price) - Number(b.productSupp)
          })
        } else {
          let item: any = {
            id: x.category,
            elements: [x],
            nbrSuppOfferts: Number(x.nbrSuppOfferts),
          }
          selectedCat.push(item)
        }
        if (j == selectedSupp.length - 1) {
          resolve(selectedCat)
        }
      }));
    })
  }

  setOffertIngPrice(cat) {
    return new Promise((resolve, reject) => {
      let selectedCat = JSON.parse(JSON.stringify(cat));
      let e = {
        totalSupp: 0,
        supplements: []
      }
      selectedCat.forEach((c, j) => {
        let totalprice = c.elements.reduce((a, b) => a + Number(b.price), 0)
        for (let i = 0; i < c.nbrSuppOfferts; i++) {
          if (c.elements[i]) {
            totalprice -= Number(c.elements[i].price);
            c.elements[i].price = 0;
            c.elements[i].offert = 1;
          }
        }
        e.totalSupp += Number(totalprice);
        e.supplements = e.supplements.concat(c.elements);
        if (j == selectedCat.length - 1) {
          resolve(e)
        }
      });
    })
  }


  async addMenu(me, toastContainer) {
    this.toastr.overlayContainer = toastContainer;
    let menu = Object.assign({}, me);
    let m: any = {
      id: menu.id,
      code: menu.code,
      title: menu.title,
      elements: [],
      additionalOptions: [],
      comment: (menu.comment) ? menu.comment : "",
      price: menu.price,
      offer: menu.offer,
      vat: menu.vat,
      qty: 1,
      total: 0,
      priceWithSupp: Number(menu.price)
    }
    if (menu.additionalOptions.length > 0) {
      m.additionalOptions = menu.additionalOptions.filter(map => map.checked);
      if (m.additionalOptions.length > 0) {
        m.total += m.additionalOptions.reduce((a, b) => +a + +b.price, 0);
      }
    }
    await new Promise((v, x) => {
      let arr = menu.compositions2.map((composition, ind) => {
        if (ind == 0 && composition.length > 0) {
          let arr = composition.map(
            (comp) => {
              if (comp.type == 1) {
                return this.addElementToMenu(comp).then(
                  (e: any) => {
                    m.elements.push(e);
                    m.total += Number(e.totalSupp);
                    return Promise.resolve(true);
                  }
                ).catch(
                  (err) => {
                    return Promise.reject(true);
                  }
                )
              }
              if (comp.type == 2) {
                let arr2 = comp.elements.map(com => {
                  return this.addElementToMenu(com[com.selectedElement]).then(
                    (e: any) => {
                      if (menu.offer != null) {
                        e.priceSuppMenu = 0;
                      }
                      m.elements.push(e);
                      m.total += Number(e.priceSuppMenu);
                      m.total += Number(e.totalSupp);
                      return Promise.resolve(true);
                    }).catch(
                      (err) => {
                        return Promise.reject(true);
                      }
                    )
                });
                return Promise.all(arr2).then(
                  () => {
                    return Promise.resolve(true);
                  }
                ).catch(
                  () => {
                    return Promise.reject(true);
                  }
                )
              }
            }
          )
          return Promise.all(arr).then(() => {
            return Promise.resolve(true);
          }).catch(
            (err) => {
              return Promise.reject(true);
            }
          )
        }
      })
      Promise.all(arr).then(() => { v(1) }).catch(
        (err) => {
          return x(true);
        }
      )
    }).then(() => {
      console.log('fin 1')
    }).catch(
      (err) => {
        return Promise.reject(true);
      }
    )

    await new Promise((v, x) => {
      let arr = menu.compositions2.map((composition, ind) => {
        if (ind > 0 && composition.length > 0) {
          let comp = composition[composition.checked];
          if (comp.type == 1) {
            return this.addElementToMenu(comp).then(
              (e: any) => {
                m.elements.push(e);
                m.total += Number(e.totalSupp);
                return Promise.resolve(true);
              }).catch(
                (err) => {
                  return Promise.reject(true);
                }
              )
          }
          if (comp.type == 2) {
            let arr2 = comp.elements.map(com => {
              return this.addElementToMenu(com[com.selectedElement]).then(
                (e: any) => {
                  if (menu.offer != null) {
                    e.priceSuppMenu = 0;
                  }
                  m.elements.push(e);
                  m.total += Number(e.priceSuppMenu);
                  m.total += Number(e.totalSupp);
                  return Promise.resolve(true);
                }).catch(
                  (err) => {
                    return Promise.reject(true);
                  }
                )
            });
            return Promise.all(arr2).then(
              () => {
                return Promise.resolve(true);
              }
            ).catch(
              () => {
                return Promise.reject(true);
              }
            )
          }
        }
      })
      Promise.all(arr).then(() => { v(1) }).catch(
        (err) => {
          return x(true);
        }
      )
    }).then(() => {
      console.log('fin 2')
    }).catch(
      (err) => {
        return Promise.reject(true);
      }
    )

    if (menu.offer == null) {
      m.total += Number(menu.price);
      this.orderTemp.menus.unshift(m);
      menu.loading = false;
      this.changeOrderTotal();
      this.toastr.success('Ajout Menu', 'Ajout réussi');
      return Promise.resolve(true);
    }
    else {
      this.offerNbrTemp++;
      this.offerNbr.next(this.offerNbrTemp);
      let prices = m.elements.map(element => element.price);
      prices = prices.join(',');
      await this.getOfferPrice({ offer: menu.offer, prices }).toPromise().then(
        (total) => {
          m.total += total;
          m.price = total;
          if (menu.offer == 7) {
            m.title = "Pizza Moitié-Moitié";
            m.elements[0].name = "Moitié " + m.elements[0].name;
            m.elements[1].name = "Moitié " + m.elements[1].name;
          }
          if (menu.offer == 9) {
            let lenght = m.elements.length / 2;
            m.title = (lenght > 1) ? lenght + " Pizza achetées, " + lenght + " Pizza offert" : lenght + " Pizza achetée, " + lenght + " Pizza offert";
          }
        }
      )
      this.orderTemp.menus.unshift(m);
      menu.loading = false;
      this.changeOrderTotal();
      this.toastr.success('Ajout Menu', 'Ajout réussi');
      this.offerNbrTemp++;
      this.offerNbr.next(this.offerNbrTemp);
      return Promise.resolve(true);
    }
  }

  getOfferPrice(params) {
    return this.http.get(this.host + 'offer/' + params.offer + '/price', { params: { prices: params.prices } })
  }

  addElementToMenu(element) {
    return new Promise(
      (resolve, x) => {
        if (!element.available) {
          this.toastr.warning('', element.name + ' indisponible', { positionClass: 'toast-top-center' });
          x(true);
        } else {
          let product = JSON.parse(JSON.stringify(element));
          if (product.custom) {
            if (!element.optionIngredients) {
              this.toastr.warning('Merci d\'ajouter les options pour ' + element.name, 'Attention', { positionClass: 'toast-top-center' });
              x(true);
            }
            product.selectedOpt = element.optionIngredients.filter(c => c.disabled == "false" && c.checked);
            if (product.selectedOpt.length == 0) {
              this.toastr.warning('Merci d\'ajouter les options pour ' + element.name, 'Attention', { positionClass: 'toast-top-center' });
              x(true);
            }
          }
          let e = {
            id: element.id,
            name: element.name,
            family: element.family,
            comment: '',
            qty: Number(element.quantity),
            size: { id: element.id, label: element.size, level: element.level },
            removedCompositions: element.compositions.filter(c => c.disabled == "false" && c.checked === false),
            supplements: [],
            optionIngredients: (element.optionIngredients) ? element.optionIngredients.filter(c => c.disabled == "false" && c.checked === true) : [],
            price: Number(element.price),
            priceSuppMenu: element.priceSuppMenu,
            totalSupp: 0
          }
          e.removedCompositions = this.orderIngredient(e.removedCompositions);
          e.optionIngredients = this.orderIngredient(e.optionIngredients);
          element.selectedSupp = (element.optionIngredients) ? element.supplements.filter(c => c.disabled == "false" && c.checked === true).map(el => { el.label = el.text; return el }) : [];
          if (element.selectedSupp && element.selectedSupp.length > 0) {
            switch (Number(element.priceSuppApp)) {
              case 1: {
                e.supplements = element.selectedSupp;
                e.totalSupp += element.selectedSupp.reduce((a, b) => +a + +b.price, 0)
                resolve(e);
                break;
              }
              case 2: {
                let arraRquest = [];
                element.selectedSupp.forEach((ele) => {
                  arraRquest.push(this.ingredientsService.getIngredientsCatFamSizeBySize(ele.category, element.family, element.idSize))
                });
                forkJoin(arraRquest).subscribe(
                  (d) => {
                    d.forEach((data, index, array) => {
                      let el = JSON.parse(JSON.stringify(element.selectedSupp[index]));
                      if (data.length > 0) {
                        el.price = Number(data[0].price);
                      }
                      e.totalSupp += Number(el.price);
                      e.supplements.push(el);
                      if (array.length - 1 == index) {
                        resolve(e);
                      }
                    })
                  }
                )
                break;
              }
              case 3: {
                element.selectedSupp.forEach((ele, index, array) => {
                  let el = JSON.parse(JSON.stringify(ele));
                  el.price = Number(element.priceSupp);
                  e.totalSupp += Number(el.price);
                  e.supplements.push(el)
                  if (array.length - 1 == index) {
                    resolve(e);
                  }
                });
                break;
              }
            }
          } else {
            resolve(e);
          }
        }
      }
    )
  }

  clearOrder() {
    this.order.next({
      elements: [],
      menus: [],
      amount: 0,
      comment: '',
      elementsNbr: 0,
      total: 0,
      discount: 0,
      discountValue: 0,
      couponCode: 0,
      coupon: 0,
      couponValue: 0,
      couponType: 0,
      fees: 0,
      feesLabel: ""
    })
    this.orderTemp = {
      elements: [],
      menus: [],
      amount: 0,
      comment: '',
      elementsNbr: 0,
      total: 0,
      discount: 0,
      discountValue: 0,
      couponCode: 0,
      coupon: 0,
      couponValue: 0,
      couponType: 0,
      fees: 0,
      feesLabel: ""
    }
    this.offerNbr.next(0);
    this.offerNbrTemp = 0;
  }

  addOrder(order) {
    order.displayCode = 0;
    return this.http.post(this.host + 'orders', order)
  }

  incrQty(i, j) {
    this.orderTemp.amount += this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
    this.orderTemp.elements[i].total += this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
    this.orderTemp.elements[i].qty++;
    this.orderTemp.elementsNbr++;
    this.changeOrderTotal();
  }

  decrQty(i, j) {
    if (this.orderTemp.elements[i].qty > 1) {
      this.orderTemp.amount -= this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
      this.orderTemp.elements[i].total -= this.orderTemp.elements[i].total / this.orderTemp.elements[i].qty;
      this.orderTemp.elements[i].qty--;
      this.orderTemp.elementsNbr--;
      this.changeOrderTotal();
    }
  }

  removeElement(i, j) {
    switch (j) {
      case 0: {
        let elementPrice = this.orderTemp.elements[i].total;
        this.orderTemp.amount -= elementPrice;
        this.orderTemp.elementsNbr -= this.orderTemp.elements[i].qty;
        this.orderTemp.elements.splice(i, 1);
        this.changeOrderTotal();
        break;
      }
      case 1: {
        if (this.orderTemp.menus[i].offer != null) {
          this.orderTemp.offerNbr -= this.orderTemp.menus[i].qty;
        }
        let menuPrice = this.orderTemp.menus[i].total;
        this.orderTemp.amount -= menuPrice;
        this.orderTemp.elementsNbr -= this.orderTemp.menus[i].qty;
        this.orderTemp.menus.splice(i, 1);
        this.changeOrderTotal();
        break;
      }
    }
  }

  updateElement(element, i) {
    const totalement = Number(this.orderTemp.elements[i].total);
    const qtyelement = Number(this.orderTemp.elements[i].qty);
    let elementsNbr = this.orderTemp.elementsNbr;
    elementsNbr -= qtyelement;
    this.orderTemp.amount -= totalement;
    // element.total *= Number(element.qty);
    this.orderTemp.elements[i] = element;
    elementsNbr += element.qty;
    this.orderTemp.elementsNbr = elementsNbr;
    this.orderTemp.amount += Number(element.total);
    this.changeOrderTotal();
  }

  getUserOrders() {
    return this.http.get(this.host + 'orders');
  }

  getOrder(id) {
    return this.http.get(this.host + 'orders/' + id + '/info');
  }

  updateOrderTransaction(params) {
    return this.http.put(this.host + 'orders/' + params.id + '/transaction', { transaction: params.transaction });
  }

  getOrderElements(id) {
    return this.http.get(this.host + 'orders/' + id + '/elements');
  }

  getOrderMenus(id) {
    return this.http.get(this.host + 'orders/' + id + '/menus');
  }

  getOrderPaymentModes(id) {
    return this.http.get(this.host + 'orders/' + id + '/paymentModes');
  }

  payOrder(token) {
    return this.http.post(this.host + 'orders/paymentModes', { token: token });
  }

  ngOnDestroy() {
    this.unsubscribe();
  }
  unsubscribe() {
    this.subscriptions.forEach((subscription: Subscription) => {
      subscription.unsubscribe();
    });
    this.subscriptions = [];
  }

  orderIngredient(array: any[]) {
    let sortedArray = array.sort((ing1: any, ing2: any) => {
      if (ing1.order < ing2.order) {
        return -1
      }
      if (ing1.order > ing2.order) {
        return 1
      }
      return 0;
    })
    return sortedArray;
  }

  changeOrderTotal() {
    this.orderTemp.amount = 0;
    this.orderTemp.elementsNbr = 0;

    this.orderTemp.elements.forEach(el => {
      this.orderTemp.amount += Number(el.total);
      this.orderTemp.elementsNbr += el.qty
    });
    this.orderTemp.menus.forEach(m => {
      this.orderTemp.amount += Number(m.total);
      this.orderTemp.elementsNbr++;
    });
    if (this.discount > 0 && this.orderTemp.amount >= this.discountFrom) {
      this.orderTemp.discount = this.discount;
      this.orderTemp.total = this.orderTemp.amount * (100 - this.discount) / 100;
      this.orderTemp.discountValue = -this.orderTemp.amount * this.discount / 100;
    } else {
      this.orderTemp.discount = 0;
      this.orderTemp.discountValue = 0;
      this.orderTemp.total = this.orderTemp.amount;
    }

    if (this.couponValue > 0) {
      if (this.orderTemp.couponType == 1) {
        this.orderTemp.couponValue = -this.couponValue;
      }
      if (this.orderTemp.couponType == 2) {
        this.orderTemp.couponValue = -this.orderTemp.total * this.couponValue / 100;
      }
      this.orderTemp.total = this.orderTemp.total + this.orderTemp.couponValue;
    }

    if (this.orderTemp.fees > 0) {
      this.orderTemp.total = Number(this.orderTemp.total) + Number(this.orderTemp.fees);
    }

    this.order.next(this.orderTemp);
  }

  getPayementData(params) {
    return this.http.get(this.host + 'payement', { params: params })
  }

  checkCoupon(coupon) {
    return this.http.get(this.host + 'coupon/' + coupon)
  }

  addCoupon(data) {
    this.orderTemp.couponCode = data.coupon;
    this.orderTemp.coupon = data.value;
    this.orderTemp.couponType = data.type;
    this.couponValue = data.value;
    this.changeOrderTotal();
  }

  removeCoupon() {
    this.orderTemp.couponCode = 0;
    this.orderTemp.coupon = 0;
    this.orderTemp.couponType = 0;
    this.couponValue = 0;
    this.changeOrderTotal();
  }

  getOrderTicket(id) {
    return this.http.get(this.host + 'ticket/orders/' + id);
  }

  checkOrderPayament(id) {
    return this.http.get(this.host + 'paid/orders/' + id);
  }

  addFees(managementFees, managementFeesSiteLabel) {
    this.orderTemp.feesLabel = managementFeesSiteLabel
    this.orderTemp.fees = Number(managementFees);
    this.changeOrderTotal();
  }
}
